import { v4 as uuidv4 } from 'uuid';

export type BrandedType<NativeType, Name> = NativeType & { __type: Name };
export type IdOf<Name> = BrandedType<string, Name>;
export function createId<Name extends string>(): IdOf<Name> {
  return uuidv4() as IdOf<Name>;
}
